import React from 'react';

interface ServiceNowIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

export const ServiceNowIcon: React.FC<ServiceNowIconProps> = ({
  width = 24,
  height = 24,
  color = '#62D84E',
  className
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={className}
      style={{ display: 'inline-block' }}
    >
      {/* ServiceNow logo - stylized service ticket and workflow */}
      <rect x="4" y="4" width="16" height="16" rx="3" fill={color} />
      <path 
        fill="white" 
        d="M8 8h8v2H8zm0 3h6v2H8zm0 3h4v2H8z"
      />
      <circle cx="16" cy="11" r="1" fill="white" />
      <circle cx="16" cy="14" r="1" fill="white" />
      <path 
        fill="white" 
        d="M18 7l-1.5 1.5L15 7l1.5-1.5L18 7z"
      />
    </svg>
  );
};
